// Official VAMMOS sand life logo lockup (sun + waves + wordmark + tagline).
// Rendered as a single image — never combine with separate wordmark text.
const LOGO_URL = "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/61n44qwx_newlogovammos.webp";

export const VLogo = ({ height = 80, className = "", invert = false, alt = "VAMMOS sand life" }) => (
  <img
    src={LOGO_URL}
    alt={alt}
    className={className}
    style={{
      height: `${height}px`,
      width: "auto",
      display: "block",
      filter: invert ? "brightness(0) invert(1)" : "none",
    }}
    draggable={false}
  />
);

export default VLogo;
